
import { defineComponent } from "vue";
import { DEFAULT_PER_PAGE_KEY } from "@/core/constants/const";

export default defineComponent({
  name: "pagination",

  emits: ["change-page", "change-page-size"],

  props: {
    total: {
      type: Number,
      required: true,
    },
    page: {
      type: Number,
      required: true,
    },
    pageSize: {
      type: Number,
      default: 30,
    },
    showPerPage: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      currentPage: this.page,
    };
  },

  watch: {
    page(value) {
      this.currentPage = value;
    },
  },

  methods: {
    change(value) {
      this.currentPage = value;

      this.$emit("change-page", this.currentPage);
    },
    changePageSize(value) {
      window.localStorage.setItem(DEFAULT_PER_PAGE_KEY, value.toString());

      this.currentPage = 1;

      this.$emit("change-page-size", value);
    },
  },
});
